import * as React from 'react';
import { clsx } from 'clsx';
import * as styles from '../../styles/col.module.css';
import { useColProps } from './internal';
import { jsx as _jsx } from "react/jsx-runtime";
export var Col = function Col(props) {
  var _useColProps = useColProps(props),
    col = _useColProps.col,
    hidden = _useColProps.hidden,
    offset = _useColProps.offset,
    offsetRight = _useColProps.offsetRight;
  if (hidden) {
    return null;
  }
  return /*#__PURE__*/_jsx("div", {
    className: clsx(styles["col_".concat(col)], Boolean(offset) && [styles["col_offset_".concat(offset)]], Boolean(offsetRight) && styles["col_offset_right_".concat(offsetRight)]),
    children: props.children
  });
};
Col.displayName = 'Col';